import React from 'react'

import {checkRegisteredCheck, queryPayInfo} from "../utils/request";
import BaseLayout from "./BaseView/BaseLayout";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import storage from "../utils/storage";
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import LoadingCard from "./components/LoadingCard";
import {withStyles} from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import Divider from '@material-ui/core/Divider';


import styles from "assets/jss/material-kit-pro-react/views/loginPageStyle.js";
import Card from "../components/Card/Card";

const useStyles = styles;


const api = global.constants.baseApi;

class InPayOnly extends React.Component {

	constructor(props) {
		super(props);

		const _type = this.props.match.params.type;
		const _orderId = this.props.match.params.orderId;
		const token = this.props.match.params.token;
		storage.set("token", token);

		this.state = {
			type: _type,
			orderId: _orderId,
			tipShow: '正在创建订单, 请稍后',
			showUpdate: true,
			showIntoNewPage: false,
		};


		switch (this.state.type) {
			case "create":
				setTimeout(() => {
					this.intoPayPage()
				}, 1000);
				break;
			case "inPay":
				// this.toAliPay();
				// alert('inPay: '+ this.state.orderId)
				break;
			case "success":
				this.state.tipShow = '正在查看支付情况, 请稍后';
				this.state.showUpdate = false;
				this.toCheckQuery();
				break;
			default:
				this.props.history.push('/welcome');
				break;
		}

		document.title = "付款中 - RobinAlgo";

	};

	intoPayPage = () => {
		const w = window.open('about:blank');
		w.location.href = api + 'plan/create_ali_pay_link/?orderId=' + this.state.orderId + '&token=' + storage.get('token');

		this.state.tipShow = '正在跳转至新的页面进行支付';
	};


	toCheckQuery = () => {
		queryPayInfo(this.state.orderId).then(res => {
			this.setState({
				showUpdate: true
			});
			switch (res.data) {
				case "0":
					this.setState({
						tipShow: '支付成功'
					});

					setTimeout(() => {
						this.props.history.push('/account');
					}, 1000);

					break;
				case "1":
					this.setState({
						tipShow: '未找到相关支付情况, 请在相关页面支付',
						showIntoNewPage: true,
					});
					break;
				case "2":
					this.setState({
						tipShow: '当前订单未支付, 请支付后重试'
					});
					break;
			}
		})
	};


	render() {
		const {classes} = this.props;

		return (
			<div style={{backgroundColor: "#2c5364"}}>


				<GridContainer justify="center" alignItems="center" className={classes.textCenter}>
					<GridItem xs={12} sm={12} md={6}>
						<Card style={{padding: '12px'}}>

							<h3>
								<CircularProgress
									color={'#fff'}/>
								&nbsp;&nbsp;&nbsp;&nbsp;{this.state.tipShow}
							</h3>

							<h4>已经完成付款?</h4>
							<Button color="primary"
								// type="submit"
									size={'lg'}
									fullWidth
									onClick={this.toCheckQuery}
							>
								查询最新的支付状态
							</Button>

							{
								this.state.showIntoNewPage ?
									<Button color="danger"
											size={'lg'}
											fullWidth
											onClick={this.intoPayPage}
									>
										跳转到网站支付
									</Button>
									:
									null
							}

							<Divider/>
							<b style={{marginTop: '12px'}}>对支付情况有疑问? 你可以通过下方的联系方式与我们取得联系.</b>
						</Card>

					</GridItem>
				</GridContainer>

				<GridContainer justify="center" alignItems="center" className={classes.textCenter}>
					<GridItem xs={12} sm={12} md={6}>
						<LoadingCard type={7}/>
					</GridItem>
				</GridContainer>

			</div>
		)
	}
}

export default withStyles(useStyles)(InPayOnly)
